/**
 * 🔊 LA VENTE SONNE CHEZ QUI — en grand chez le vendeur, en discret ailleurs.
 *
 * Kayla, 08-09-2026 (audit « Cyrano chauffe, l'humain vend ») : la vente doit
 * tomber sur l'écran de CELUI qui a vendu. Le son existait déjà, au même
 * volume pour tous les membres connectés de l'org. Désormais l'événement
 * porte `sellerWorkosUserId` (l'humain qui a vendu, `null` pour Cyrano) : on
 * le compare à la session ouverte.
 *
 *   · c'est MOI qui ai vendu  → plein volume ;
 *   · quelqu'un d'autre, ou Cyrano → discret. La preuve sociale d'entendre
 *     les autres vendre garde sa valeur ; elle ne doit pas couvrir la mienne.
 *
 * Fonction pure, testée sans audio (`__tests__/paymentVolume.test.ts`).
 */

/** Le volume de la petite fête, chez ceux qui n'ont pas vendu. */
export const VOLUME_DISCRET = 0.3;

export function estMaVente(
  sellerWorkosUserId: string | null | undefined,
  monWorkosUserId: string | null | undefined,
): boolean {
  return Boolean(sellerWorkosUserId) && sellerWorkosUserId === monWorkosUserId;
}
